import { render, staticRenderFns } from "./VerPorTipo.vue?vue&type=template&id=777d172a&"
import script from "./VerPorTipo.vue?vue&type=script&lang=js&"
export * from "./VerPorTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports